import { FC, ReactNode } from 'react';
import { mergeTailwindClasses } from '@kontentino/ui';
import clsx from 'clsx';

interface CardProps {
  children: ReactNode;
  className?: string;
  'data-cy'?: string;
}

const Card: FC<CardProps> = ({ children, className, 'data-cy': dataCy }) => {
  return (
    <div
      className={mergeTailwindClasses(
        clsx(
          'tw-flex tw-flex-col tw-items-start tw-gap-2 tw-rounded-xl tw-bg-white tw-p-4',
          className,
        ),
      )}
      data-cy={dataCy}
    >
      {children}
    </div>
  );
};

export default Card;
